import { template as _$template } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=flight-loading>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class=flight__message>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<p class="flight__message flight__message--error">`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=flight__overlay>`);
import { Show } from "solid-js";
import { WEBGPU_UNAVAILABLE_NOTE } from "../three/webgpu-support.ts";
import { FlightLoadingScreen } from "./FlightLoadingScreen.tsx";
import { BootReportPanel, bootReportRequested } from "./BootReportPanel.tsx";
/**
 * The full-screen pane shown until the scene is `"ready"`. Split out of
 * `Fly.tsx` to keep that route's own function under the size gate (same
 * reasoning as `FlightSettingsControls.tsx`).
 *
 * Two different things wear one name here, deliberately. `initializing` is the
 * **loading screen** — a 320×200 shell frame with a bar reporting the boot's own
 * phases (`FlightLoadingScreen.tsx`), which is the ordinary case and should look
 * like the game. `unavailable` and `error` are **diagnostics**: prose the player
 * is meant to read and possibly quote back, sometimes a whole WebGPU error
 * string, and they stay in DOM text where they can wrap, be selected and be
 * copied. Setting a browser error in a 5-pixel bitmap font would be a costume,
 * not a port.
 */
export function FlightStatusOverlay(props) {
  const status = () => props.boot.status();
  return [_$createComponent(Show, {
    get when() {
      return bootReportRequested();
    },
    get children() {
      return _$createComponent(BootReportPanel, {});
    }
  }), _$createComponent(Show, {
    get when() {
      return status() !== "ready";
    },
    get children() {
      return [_$createComponent(Show, {
        get when() {
          return status() === "initializing";
        },
        get children() {
          var _el$ = _tmpl$();
          _$insert(_el$, _$createComponent(FlightLoadingScreen, {
            get progress() {
              return props.boot.progress();
            }
          }));
          return _el$;
        }
      }), _$createComponent(Show, {
        get when() {
          return _$memo(() => status() !== "initializing")() && status() !== "ready";
        },
        get children() {
          var _el$2 = _tmpl$4();
          _$insert(_el$2, _$createComponent(Show, {
            get when() {
              return status() === "unavailable";
            },
            get children() {
              var _el$3 = _tmpl$2();
              _$insert(_el$3, WEBGPU_UNAVAILABLE_NOTE);
              return _el$3;
            }
          }), null);
          _$insert(_el$2, _$createComponent(Show, {
            get when() {
              return status() === "error";
            },
            get children() {
              var _el$4 = _tmpl$3();
              _$insert(_el$4, () => props.boot.errorMessage());
              return _el$4;
            }
          }), null);
          return _el$2;
        }
      })];
    }
  })];
}